import React, { useEffect, useState } from "react";
import { ValidateResponse, getCurrentPage, setCurrentPage } from "../../helpers/global";
import { fetchDepotOnDate } from "../../helpers/management";
import { List } from "../../../components/List";
import { ListPagination } from "../../../components/List/Pagination";
import { Message } from "../../../components/Message";
import { returnValues, removeValue, validateData } from "../../../components/Form/Formfunctions";
import { FormFields } from "../../../components/Form/Fields";
import { FormInputSubmit } from "../../../components/Form/Input/Submit";
import { ContentWrapper } from "../../../components/Content/Wrapper";
import { ContentGenerateExcel } from "../../../components/Content/GenerateExcel";

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function AppManagementOverviewsDepotDate({ current, identifier, filterValues, setFilterFields }) {

    let pageSize = 10; // default values ergens globaal opslaan?

    const [cases, setCases] = useState();
    //const [contacts, setContacts] = useState();
    const [isLoaded, setIsLoaded] = useState(false);
    const [loadFilters, setLoadFilters] = useState(true);
    const [pageNr, setPageNr] = useState(getCurrentPage(current));
    const [totalCount, setTotalCount] = useState(0);
    const [error, setError] = useState();
    const [errors, setErrors] = useState();
    const [values, setValues] = useState({});
    const [filters, setFilters] = useState(JSON.parse(localStorage.getItem("filters" + identifier)) ?? {});
    const [filterString, setFilterString] = useState("{}");
    const [isSubmitted, setSubmitted] = useState(false);
    const [documentName, setDocumentName] = useState();
    const [viewMode, setViewMode] = useState();

    const defineFilterFields = () => {
        let filterFields = {
            date: {
                type: "date",
                label: 'datum',
                options: { min: "-125", max: null },
            },
            depotCategory: { type: 'categories', label: "Artikelcategorie", options: { output: "depot", category: "categoryId", article: "articleId" } },
        };

        setFilterFields(filterFields);
    }

    useEffect(() => {

        if (isSubmitted === false) {
            return;
        }

        let validation = validateData(formFields, values, true);

        if (validation.status !== 'success' || (!values.date)) {
            setErrors(validation.errors);
            setSubmitted(false);
            return;
        }

        fetchData(1, viewMode);
        
    }, [pageNr, filters, filterString, pageSize])

    let formFields = {
        date: {
            type: "date",
            label: 'Datum',
            options: { min: "-125", max: null },
            rules: ['required'],
        },
        depotCategory: { type: 'categories', label: "Artikelcategorie", options: { output: "depot", category: "categoryId", article: "articleId" } },
    }

    const setInputValues = (key, value) => {

        // reset errors
        if (isSubmitted === true) {
            setSubmitted(false);
        }
        if (errors) {
            setErrors(removeValue(errors, key, null));
        }

        setValues(returnValues(values, key, value, null));
        setFilters(returnValues(values, key, value, null));
        localStorage.setItem("filters" + identifier, JSON.stringify(returnValues(values, key, value, null)));
    }

    const setInputErrors = (key, value, identifier = null) => {

        // add or remove error
        let newErrors = errors;
        if (value !== undefined && value !== null) {
            newErrors = returnValues(errors, key, value, identifier);
        }
        else {
            newErrors = removeValue(errors, key, identifier);
        }
        setErrors(newErrors);
    }

    if (pageNr !== getCurrentPage(current)) {
        setPageNr(getCurrentPage(current));
    }


    let groupedColumns = [
        { key: "numberOfProducts", label: "Aantal", type: "text" },
        { key: "articleName", label: "Artikel", type: "text" },
        { key: "categoryName", label: "Categorie", type: "text" }
    ];

    let listColumns = [
        { key: "serialNumber", label: "Serienummer", type: "text" },
        { key: "articleName", label: "Artikel", type: "text" },
        { key: "articleGroup", label: "Categorie", type: "text" },
        { key: "startDate", label: "Start depot", type: "date" },
        { key: "endDate", label: "Eind depot", type: "date" }
    ];

    const fetchData = (page, useMode) => {

        setTotalCount();
        setCases();
        setSubmitted(true);

        var filterData = filters;
        const callData = {
            tabType: current,
            filters: {
                limitOffset: pageSize * page - (pageSize - 1),
                limitRows: pageSize,
                viewMode: useMode,
                ...filterData
            }
        }

        fetchDepotOnDate(callData).then((res) => {
            const response = ValidateResponse(res.data, 'depot');

            if (response.status === 'success') {
                if (response.documentName !== undefined) {
                    setDocumentName(response.documentName);
                }
                if (response.totalCount !== undefined) {
                    setTotalCount(response.totalCount);
                    if (loadFilters !== current) {
                        setLoadFilters(current);
                        defineFilterFields();
                    }
                }
                setCases(response.depot);
                setIsLoaded(true);
            }
            else {
                setError(response.message);
            }

        }).catch((error) => {
            const response = ValidateResponse(error);
            setError(response.message);
        });
    }

    // if (JSON.stringify(filterValues) !== filterString) {
    //     fetchData(1, filterValues);
    //     setFilterString(JSON.stringify(filterValues));
    //     setIsLoaded(false);
    //     setFilters(filterValues);
    //     setCurrentPage(1, current, setPageNr);
    // }

    if (error !== undefined) {
        return (<Message type="error" message={error} />);
    }

    const submitGrouped = () => {
        setViewMode('grouped');
        setCurrentPage(1, current, setPageNr);
        setSubmitted(true);

        let validation = validateData(formFields, values, true);

        if (validation.status !== 'success' || (!values.date)) {
            setErrors(validation.errors);
            setSubmitted(false);
            return;
        }

        fetchData(1, 'grouped');
    }

    const submitList = () => {
        setViewMode('list');
        setCurrentPage(1, current, setPageNr);
        setSubmitted(true);

        let validation = validateData(formFields, values, true);

        if (validation.status !== 'success' || (!values.date)) {
            setErrors(validation.errors);
            setSubmitted(false);
            return;
        }

        fetchData(1, 'list');
    }

    const handlePagination = (page) => {
        setCurrentPage(page, current, setPageNr);
        fetchData(page, viewMode);
    }

    const content = () => {
        return (<div className="text-component">
            <FormFields
                formFields={formFields}
                setValues={setInputValues}
                setErrors={setInputErrors}
                formValues={values}
                formErrors={errors}
                isSubmitted={isSubmitted}
            />

            <FormInputSubmit handleSubmit={submitGrouped} submitLabel="Toon totalen" cancelFunction={submitList} cancelLabel="Toon producten" />

        </div>
        )
    }

    const excelbutton = () => {
        return <ContentGenerateExcel
            documentType={'depot-on-date'}
            filters={filters}
            display={'button-download'}
            fileName={documentName}
            mimeType={'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
            label={'Download excel'}
        />
    }

    return (
        <>
            {
                <ContentWrapper type='outline-box' content={content()} />
            }

            {cases !== 'NULL' && cases !== undefined && cases.viewMode == 'grouped' &&
                <>
                    {
                        Object.keys(cases).length > 0 &&
                        <ContentWrapper type='page-component' className="floating-button" content={excelbutton()} />
                    }


                    < List
                        columns={groupedColumns}
                        data={cases.cases}
                        identifier="customers"
                    />

                    <div className={'spacer'}></div>
                    <ListPagination
                        className="pagination-bar"
                        currentPage={pageNr}
                        totalCount={totalCount}
                        pageSize={pageSize}
                        setCurrentPage={handlePagination}
                    />
                    <div className={'spacer'}></div>
                </>
            }


            {cases !== 'NULL' && cases !== undefined && cases.viewMode == 'list' &&
                <>
                    {
                        Object.keys(cases).length > 0 &&
                        <ContentWrapper type='page-component' className="floating-button" content={excelbutton()} />
                    }

                    < List
                        columns={listColumns}
                        data={cases.cases}
                        identifier="customers"
                    />

                    <div className={'spacer'}></div>
                    <ListPagination
                        className="pagination-bar"
                        currentPage={pageNr}
                        totalCount={totalCount}
                        pageSize={pageSize}
                        setCurrentPage={handlePagination}
                    />
                    <div className={'spacer'}></div>
                </>
            }
        </>
    );
}